import config from "../../config";
import { apiFetch } from "./apiFetch";
import { requestError } from "./requestError";

/* Email one Sales / Purchasing / Finance document, with its PDF attached.
   { documentType, documentId, to: [], cc: [], subject, message, pdfBase64 }
   The server checks the user may send it, that it is Approved and the addresses. */
export const sendDocumentEmail = async (payload) => {
    const res = await apiFetch(`${config.apiUrl}/sendDocumentEmail`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
    });
    if (!res.ok) throw await requestError(res);
    return res.json();
};
